// CAPABILITY: Chat text sanitization (client preview copy)
// Authoritative sanitization runs server-side in functions/chatText.js; this is
// the matching client copy used for the composer preview/counter so what the
// viewer sees ~= what gets stored. Keep the two implementations in sync.
// INPUTS: raw user string
// OUTPUTS: plain-text, no-markdown, no-HTML, whitespace-collapsed string

const ZERO_WIDTH = /[\u200B-\u200D\uFEFF\u2060]/g;
const CONTROL_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

export function sanitizeChatText(input, { maxChars = 500 } = {}) {
  if (typeof input !== "string") return "";

  let text = input
    .replace(CONTROL_CHARS, "")
    .replace(ZERO_WIDTH, "")
    // Neutralize markdown/HTML-significant characters by stripping the tokens
    // that produce links/images/formatting. We render plain text only.
    .replace(/[<>]/g, "")
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1") // ![alt](url) -> alt
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1") // [text](url) -> text
    .replace(/[*_`~]+/g, "") // bold/italic/code/strike markers
    .replace(/^#{1,6}\s+/gm, "") // heading markers
    .replace(/^>\s?/gm, ""); // blockquote markers

  // Collapse runs of whitespace/newlines.
  text = text.replace(/[ \t]{2,}/g, " ").replace(/\n{3,}/g, "\n\n").trim();

  if (text.length > maxChars) text = text.slice(0, maxChars).trim();
  return text;
}

export default sanitizeChatText;
